const EVENT_TITLE = 30;
const EVENT_DESCRIPTION = 100;
const TEACHER_NOTE = 30;
const PIECE_DESCRIPTION = 100;
const PIECE_TITLE = 40;
const STUDENT_NAME = 20;

export {
  EVENT_DESCRIPTION,
  EVENT_TITLE,
  TEACHER_NOTE,
  PIECE_TITLE,
  PIECE_DESCRIPTION,
  STUDENT_NAME,
};
